
const env = {
   BASE_URL: 'https://xenon-chain-387522.ew.r.appspot.com',
   //BASE_URL:'http://localhost:3001',
   //SOCKET_PATH:'http://localhost:3001',
   SOCKET_PATH:'https://xenon-chain-387522.ew.r.appspot.com'
}

export default env